angular.module('signup', ['pb.core', 'company', 'customer', 'contributor']);
